// import lazyLoad from '@helper/lazy-load'

const router = [
    // {
    //     path: '/app/logistics',
    //     element: lazyLoad(() => import('@pages/logistics/components/main')),
    //     loader: () => ({
    //         menuIndex: 4,
    //         key: 'logistics.logistics',
    //         icon: 'icon-wuliu',
    //         show: true
    //     })
    // }
]

export default router
